import { render, staticRenderFns } from "./productContainer.vue?vue&type=template&id=31b64a9e&scoped=true"
import script from "./productContainer.vue?vue&type=script&lang=js"
export * from "./productContainer.vue?vue&type=script&lang=js"
import style0 from "./productContainer.vue?vue&type=style&index=0&id=31b64a9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b64a9e",
  null
  
)

export default component.exports